import { DirectionProvider } from '@radix-ui/react-direction';
import { createRouter, RouterProvider } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { routeTree } from './routeTree.gen';
import { queryClient } from './services/queryClient';
import { useAuthStore } from './store/auth';
import { ToastProvider } from '@opaz/ui-components';
import { ErrorBoundary } from './components/ErrorBoundary';
import { PrivacyProvider } from './context/PrivacyContext';

const router = createRouter({
  routeTree: routeTree,
  context: {
    queryClient,
    authStore: useAuthStore,
    getBreadcrumbData: () => {
      return {
        id: null,
        translationKey: null,
      };
    },
  },
  defaultPreload: 'intent',
  // Since we're using React Query, we don't want loader calls to ever be stale
  // This will ensure that the loader is always called when the route is preloaded or visited
  defaultPreloadStaleTime: 0,
});
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

const App = () => {
  const { i18n } = useTranslation();

  return (
    <ErrorBoundary>
      <PrivacyProvider>
        <DirectionProvider dir={i18n.dir()}>
          <ToastProvider>
            <RouterProvider
              router={router}
              defaultPreload="intent"
              context={{
                queryClient,
                authStore: useAuthStore,
              }}
            />
          </ToastProvider>
        </DirectionProvider>
      </PrivacyProvider>
    </ErrorBoundary>
  );
};

export default App;
